import React, { useContext } from 'react'
import {
    FaArrowAltCircleUp,
    FaRegArrowAltCircleUp,
    FaSlidersH,
    FaThList,
    FaAngleUp,
    FaAngleDown,
} from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import ExpandButton from '../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import CollapseButton from '../../../elem/list/CollapseButton'

export default ({
    name,
    filterExpanded,
    toggleFilter,
    togglePromotedRecords,
    promotedRecords,
    setCollapsed,
    isCollapsed,
}) => {
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'wellPanelHeader'}>
            <div className="panelHeaderText">Station Explorer</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    {!filterExpanded && (
                        <div
                            className="panelHeaderIconDiv"
                            data-tooltip-content={`${
                                promotedRecords
                                    ? `Do not promote Selected Records`
                                    : `Promote Selected Records`
                            }`}
                            data-tooltip-id={`well-promoted-records-toggle-${promotedRecords}`}
                            onClick={() =>
                                togglePromotedRecords(!promotedRecords, 'well')
                            }
                        >
                            {promotedRecords ? (
                                <FaArrowAltCircleUp />
                            ) : (
                                <FaRegArrowAltCircleUp />
                            )}
                            <Tooltip id={`well-promoted-records-toggle-${promotedRecords}`} />
                        </div>
                    )}
                    <div
                        className="panelHeaderIconDiv"
                        data-tooltip-content={`${
                            filterExpanded
                                ? 'View Station List'
                                : 'View Station Filter'
                        }`}
                        data-tooltip-id={`well-view-toggle-${filterExpanded}`}
                        onClick={() => toggleFilter(!filterExpanded)}
                    >
                        {filterExpanded ? <FaThList /> : <FaSlidersH />}
                        <Tooltip id={`well-view-toggle-${filterExpanded}`} />
                    </div>
                    {isExpanded ? null : (
                    <CollapseButton
                        name={`well-list`}
                        isCollapsed={isCollapsed}
                        setCollapsed={setCollapsed}
                    />
                    )}
                    <ExpandButton
                        name={name}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
